import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { EventsService } from '../../services/events.service';
import * as $ from 'jquery';

const DELAY = 2000;

@Component({
  selector: 'app-notice-overlay',
  templateUrl: './notice-overlay.component.html',
  styleUrls: ['./notice-overlay.component.scss']
})
export class NoticeOverlayComponent implements OnInit {
  open = false;
  timeout;
  $html;
  $body;

  @HostListener('document:keydown', ['$event']) onKeydown(event) {
    if (event.keyCode === 27) {
      this.closeOverlay(event, true);
    }
  }

  constructor(public el: ElementRef, public events: EventsService) { }

  ngOnInit() {
    this.timeout = setTimeout(() => {
      const close = this.el.nativeElement.querySelector('.close-button');
      this.open = true;

      setTimeout(() => {
        close.focus();
        clearTimeout(this.timeout);
      }, 0);
    }, DELAY);

    this.events.on('toggle:notice', (status) => {
      this.open = status;
    });
  }

  closeOverlay(event?, force?: boolean) {
    const classes = event.target.classList;
    if ((classes.contains('notice-overlay') || classes.contains('inner-large')) || force) {
      this.open = false;
      this.events.broadcast('toggle:notice', this.open);
    }

    if (classes.contains('cards-button')) {
      this.$html = $('html');
      this.$body = $('body');

      this.$html.removeClass('no-scroll');
      this.$body.removeClass('no-scroll');

      document.ontouchmove = function (e) {
        return true;
      };
    }
  }

}
